import $ from 'jquery';


// Hide notice when close button is clicked
$(document).on('click', '.woocommerce-notice-close', function() {
    $(this).closest('.woocommerce-error, .woocommerce-info, .woocommerce-message').fadeOut();
});


jQuery(function($) {
    // Save a reference to the original method
    var originalAjax = $.ajax;

    // Override jQuery.ajax
    $.ajax = function(settings) {
        // Intercept WooCommerce update_order_review AJAX call
        let chk = $('#ship-to-different-address-checkbox').prop('checked');
        let vat_field = (chk) ? 'shipping_vat_number' : 'billing_vat_number';

        if (typeof settings.data === 'object' && settings.url && settings.url.indexOf('wc-ajax=update_order_review') !== -1) {
            // Convert query string into object
            var params = new URLSearchParams(settings.data.post_data);
            // Modify any field you want here (without changing DOM)
            if(params.get(vat_field) == 'IT'){
                params.set(vat_field, ''); //set to empty
            }
            // Rebuild the modified query string
            settings.data.post_data = params.toString();
        }
        
        if (typeof settings.data === 'string' && settings.url && settings.url.indexOf('wc-ajax=checkout') !== -1) {
            // Convert query string into object
            var params = new URLSearchParams(settings.data);
            // Modify any field you want here (without changing DOM)
            if(params.get(vat_field) == 'IT'){
                params.set(vat_field, ''); //set to empty
            }
            // Rebuild the modified query string
            settings.data = params.toString();

        }
        // Proceed with the original AJAX call
        return originalAjax.call(this, settings);
    };
    
});



